/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, ErrorHandler } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbAuthService } from '@nebular/auth';
import {HttpClient} from '@angular/common/http';
import { OnboardingService, OnboardingItem, OnboardingButtonComponent } from '@rosen-group/ngx-onboarding';

@Component({
  selector: 'ngx-app',
  template: `<router-outlet></router-outlet>`,
  providers:[OnboardingButtonComponent]
})
export class AppComponent implements OnInit {
  
  screenHeight:any;
	screenWidth:any;
	onboarding:string;
	Gloabalonboardingg: string;
	title = 'ngx-onboarding-app';
	  infoMessage = '';
	  private unregisterOnboarding: Function;

  constructor(private analytics: AnalyticsService,private nbauthservice : NbAuthService,  private onboardingService: OnboardingService,
    private httpClient: HttpClient,
    private errorHandler: ErrorHandler,
    private onboardingservice : OnboardingButtonComponent,) {
    this.getScreenSize();
  }

  ngOnInit(): void {	this.loadAndRegisterOnboardingData();
  }

  public ngOnDestroy() {
	if (this.unregisterOnboarding) {
		this.unregisterOnboarding();
	}
  }

  private loadAndRegisterOnboardingData() {
	this.httpClient.get('assets/onboarding/example.json').subscribe((onboardingItems: Array<OnboardingItem>) => {
		this.unregisterOnboarding = this.onboardingService.register(onboardingItems);
	}, (error) => {
		this.infoMessage = `Onboarding: ${this.formatError(error)}`;
		this.errorHandler.handleError(error);
	});
  }

  private formatError(error: any): string {
	if (typeof error === 'string') {
		return error;
	}
	if (typeof error === 'object') {
		let res = '';
		if (error.constructor && error.constructor.name) {
			res += `[${error.constructor.name}] `;
		}
		if (error.message) {
			res += error.message;
		}

		return res.length > 0 ? res : '' + error;
	}
	return error;
}

getScreenSize(event?) {
	this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
}
}
